module.exports = __webpack_public_path__ + "e0bca3f06e2128f0bc8c396bcdcdb803.svg";